import Vue from 'vue'
import VueRouter, { RawLocation, Route, RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import UserLayout from '@/layout/UserLayout.vue'
import ErrorLayout from '@/layout/ErrorLayout.vue'
import BasicLayout from '@/layout/BasicLayout.vue'
import Layout from '@/layout/Layout.vue'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push as unknown as Promise<Route>
VueRouter.prototype.push = function push(location: RawLocation) {
  return (originalPush as any).call(this, location).catch((err: Error) => err)
}
const publicRoutes: Array<RouteConfig> = [
  {
    path: '/user',
    name: 'User',
    component: UserLayout,
    redirect: '/user/login',
    children: [
      {
        path: '/user/login',
        name: 'Login',
        component: () =>
          import(/* webpackChunkName: "Login" */ '../views/User/Login/index'),
      },
    ],
  },
  {
    path: '/screen',
    name: 'Screen',
    component: () =>
      import(/* webpackChunkName: "Screen" */ '@/views/ScreenDisplay'),
  },
  {
    path: '/bigscreen',
    name: 'Bigscreen',
    component: () => import('@/views/Bigscreen/index.vue'),
  },
]

const routes: Array<RouteConfig> = [
  ...publicRoutes,
  {
    path: '/',
    name: 'Main',
    component: BasicLayout,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import(/* webpackChunkName: "Home" */ '@/views/Home'),
        meta: {
          title: '首页',
        },
      },
      {
        path: '/msgenterprise',
        name: 'Msgenterprise',
        meta: {
          title: '企业信息',
        },
        component: () => import('@/views/MsgEnterprise')
      },
      {
        path: '/companyInfo',
        name: 'CompanyInfo',
        meta: {title: '企业信息'},
        redirect: '/energySupervision',
        component: () => import(/* webpackChunkName: "CompanyInfo" */ '../views/MsgEnterprise/DailySupervision/Energy.vue'),
        children: [
            {
                path: '/energySupervision',
                name: 'EnergySupervision',
                meta: {title: '节能管理制度'},
                component: () => import(/* webpackChunkName: "CompanyInfo" */ '../views/MsgEnterprise/DailySupervision/EnergySupervision.vue'),
            },
            {
                path: '/manufacturTechnique',
                name: 'ManufacturTechnique',
                meta: {title: '生产工艺'},
                component: () => import(/* webpackChunkName: "CompanyInfo" */ '../views/MsgEnterprise/DailySupervision/ManufacturTechnique.vue'),
            },
            {
                path: '/energyUtilization',
                name: 'EnergyUtilization',
                meta: {title: '能源利用状况报告'},
                component: () => import(/* webpackChunkName: "EquipmenEnergyEfficiency" */ '../views/MsgEnterprise/DailySupervision/EnergyUtilization.vue'),
            },
            {
                path: '/energyEquipment',
                name: 'EnergyEquipment',
                meta: {title: '重点耗能设备信息'},
                component: () => import(/* webpackChunkName: "EnergyStructure" */ '../views/MsgEnterprise/DailySupervision/EnergyEquipment.vue'),
            },
             {
                path: '/majorProductDatas',
                name: 'MajorProductDatas',
                meta: {title: '计量器具配备信息'},
                component: () => import(/* webpackChunkName: "CompanyInfo" */ '../views/MsgEnterprise/DailySupervision/InstrumentsEquipped.vue'),
            },
            {
                path: '/energyConsumption',
                name: 'EnergyConsumption',
                meta: {title: '能源消费情况'},
                redirect: '/energyConstruction',
                component: () => import(/* webpackChunkName: "CompanyInfo" */ '../views/MsgEnterprise/DailySupervision/EnergyConsumption/index.vue'),
                children:[
                    {
                        path: '/energyConstruction',
                        name: 'EnergyConstruction',
                        meta: {title: '能源消费结构'},
                        component: () => import(/* webpackChunkName: "CompanyInfo" */ '../views/MsgEnterprise/DailySupervision/EnergyConsumption/EnergyConsumption.vue'),
                    }, 
                    {
                        path:'/majorProducts',
                        name:'MajorProducts',
                        meta:{title:'主要产品产量'},
                        component: () => import(/* webpackChunkName: "CompanyInfo" */ '../views/MsgEnterprise/DailySupervision/EnergyConsumption/majorProducts.vue'),
                    },
                    {
                        path:'/specificEnergycons',
                        name:'SpecificEnergycons',
                        meta:{title:'单位产品能耗'},
                        component: () => import(/* webpackChunkName: "CompanyInfo" */ '../views/MsgEnterprise/DailySupervision/EnergyConsumption/SpecificEnergycons.vue'),
                    },
                    {
                        path:'/specificEnergyconsValue',
                        name:'SpecificEnergyconsValue',
                        meta:{title:'单位产值能耗'},
                        component: () => import(/* webpackChunkName: "CompanyInfo" */ '../views/MsgEnterprise/DailySupervision/EnergyConsumption/SpecificEnergyconsValue.vue'),
                    },
                    {
                        path:'/equipmentEfficiency',
                        name:'EquipmentEfficiency',
                        meta:{title:'设备能效'},
                        component: () => import(/* webpackChunkName: "CompanyInfo" */ '../views/MsgEnterprise/DailySupervision/EnergyConsumption/EquipmentEfficiency.vue'),
                    },
                    {
                        path:'/carbonEmission',
                        name:'CarbonEmission',
                        meta:{title:'碳排放'},
                        component: () => import(/* webpackChunkName: "CompanyInfo" */ '../views/MsgEnterprise/DailySupervision/EnergyConsumption/CarbonEmission.vue'),
                    }
                ]
            }
        ]
    },
      {
        name: 'SupervisionRecord',
        path: '/SupervisionRecord',
        component: Layout,
        redirect: '/supervisionRecord/scenesupervision',
        meta: {
          title: '节能监察',
        },
        children: [
          {
            name: 'SceneSupervision',
            meta: {
              title: '现场监察',
            },
            path: '/supervisionRecord/scenesupervision',
            component: () =>
              import(
                /* webpackChunkName: "SceneSupervision" */ '@/views/SupervisionRecord/SceneSupervision'
              ),
          },
          {
            name: 'secenadd',
            path: '/supervisionsenc/add',
            component: () => import(/* webpackChunkName: "WrittenSupervision" */ '@/views/SupervisionRecord/SceneSupervision/components/EditSence')
          },
      
          {
            name: 'WrittenSupervision',
            meta: {
              title: '书面监察',
            },
            path: '/supervisionRecord/writtenSupervision',
            component: () =>
              import(
                /* webpackChunkName: "WrittenSupervision" */ '@/views/SupervisionRecord/WrittenSupervision'
              ),
          },{
            name:'',
            path: '/supervisionsenc/info',
            component: () =>
              import(
                /* webpackChunkName: "WrittenSupervision" */ '@/views/SupervisionRecord/SceneSupervision/components/SenceSupervisionInfo'
              ),
          },
          {
            name: 'WritenAdd',
            path: '/supervisionWriten/add',
            component: () => import(/* webpackChunkName: "WrittenSupervision" */ '@/views/SupervisionRecord/WrittenSupervision/components/EditWriten')
          },

          {
            name:'SupervisionInfo',
            path:'/supervisionWriten/supervisionInfo',
            component: () => import(/* webpackChunkName: "WrittenSupervision" */ '@/views/SupervisionRecord/WrittenSupervision/components/SupervisionInfo')
          }
          
        ],
      },
      {
        name: 'SystemSeting',
        path: '/SystemSeting',
        component: Layout,
        redirect: '/SystemSeting/OrganizationManage',
        meta: {
          title: '系统管理',
        },
        children: [
          {
            name: 'OrganizationManage',
            meta: {
              title: '人员管理',
            },
            path: '/systemSeting/organizationManage',
            component: () =>
              import(
                /* webpackChunkName: "SceneSupervision" */ '@/views/SystemSeting/OrganizationManage'
              ),
          },
          {
            name: 'TempManage',
            meta: {
              title: '文书模板管理',
            },
            path: '/systemSeting/tempManage',
            component: () =>
              import(
                /* webpackChunkName: "SceneSupervision" */ '@/views/SystemSeting/TempManage'
              ),
          },
          {
            name:'adddoctemp',
            path:'/system/tempmange/add',
            component: () => import(/* webpackChunkName: "WrittenSupervision" */ '@/views/SystemSeting/TempManage/components/DocumentModal')
          }
        ],
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
